export function hasPathnamePrefixed(locale: string, pathname: string | null): boolean {
    const prefix = `/${locale}`;
    return pathname === prefix || (!!pathname && pathname.startsWith(`${prefix}/`));
}
